var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"angular-placeholder"},[_vm._v("angular routing placeholder")])
}
var staticRenderFns = []

export { render, staticRenderFns }